<template>
  <div id="tabs" class="tabs is-toggle is-fullwidth">
    <ul>
        <li :class="{ 'is-active': isActive('/account') }">
            <a @click="$router.push('/account/profile')">
                <span class="icon"><i class="fa fa-user"></i></span>
                <span>{{ $t("Account") }}</span>
            </a>
        </li>
        <li :class="{ 'is-active': isActive('/wallet') }">
            <a @click="$router.push('/wallet/buy')">
                <span class="icon"><i class="fa fa-exchange"></i></span>
                <span>{{ $t("Wallet") }}</span>
            </a>
        </li>
          <li v-if="hasPermission('Household', 'Edit')" :class="{ 'is-active': isActive('/households') }">
              <a @click="$router.push('/households')">
                  <span class="icon"><i class="fa fa-home"></i></span>
                  <span>{{ $t("Households") }}</span>
              </a>
          </li>
    </ul>
</div>
</template>

<script>
export default {
  name: "NavigationTabs"
};
</script>